import React from 'react'

function UserPermission() {
  return (
    <div>UserPermission</div>
  )
}

export default UserPermission